(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mewant-collection-seo-top-de"]) return;
  try {
    
  (() => {
    const mount = () => {
      document.querySelectorAll('[data-mewant-h1-slot]').forEach((slot) => {
        const title = document.querySelector('.collection__title');
        if (!title || slot.contains(title)) return;
        title.textContent = slot.dataset.mewantH1;
        slot.append(title);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mewant-mercedes-collection-seo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountMercedesHeading = () => {
      const slot = document.querySelector('[data-mewant-mercedes-h1-slot]');
      const title = document.querySelector('.collection__title');
      if (!slot || !title || slot.contains(title)) return;
      title.textContent = slot.dataset.mewantMercedesH1;
      slot.append(title);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountMercedesHeading);
    } else {
      mountMercedesHeading();
    }

    document.addEventListener('shopify:section:load', mountMercedesHeading);
  })();

  } catch(e) { console.error(e); }
})();
})();
